import React, { useEffect, useState } from 'react';
import { FaArrowLeft, FaPlus } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap';
import styled from 'styled-components';
import {
  setActivoNewsletterAction,
  setActivoTiposBoletinAction,
} from '../../../store/actions';
import {
  IS_LIST_TIPOS_BOLETIN,
  SET_NEWSLETTER_ACTIVO,
  SET_TIPOS_BOLETIN_ACTIVO,
} from '../../../store/types';
import FormNewsletter from './components/FormNewsletter';
import FormTiposBoletin from './components/FormTiposBoletin';
import ListadoNewletter from './components/ListaNewsletter';
import ListadoTiposBoletin from './components/ListaTiposBoletin';

const Container = styled.div`
  width: 100%;
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
`;

const PageHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;
`;

const TitleBlock = styled.div`
  h2 {
    margin: 0 0 0.25rem;
    font-size: 1.5rem;
    font-weight: 700;
    color: #212529;
  }

  p {
    margin: 0;
    font-size: 0.875rem;
    color: #6c757d;
  }
`;

const Toolbar = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem;
`;

const Breadcrumb = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.8rem;
  color: #6c757d;
  padding: 0.5rem 0.75rem;
  background: #f8f9fa;
  border-radius: 6px;
  border: 1px solid #e9ecef;

  strong {
    color: #212529;
  }
`;

export const Newsletter = () => {
  const dispatch = useDispatch();

  const tiposBoletinState = useSelector((state) => state.tiposBoletin);
  const newsletterState = useSelector((state) => state.newsletter);

  const [isModalNewsletter, setIsModalNewsletter] = useState(false);
  const [isModalTipo, setIsModalTipo] = useState(false);

  const isListView = tiposBoletinState.isList;
  const tipoActivo = tiposBoletinState.activo;

  const openTipoModal = (tipo = null) => {
    setActivoTiposBoletinAction(dispatch, tipo);
    setIsModalTipo(true);
  };

  const closeTipoModal = () => {
    setIsModalTipo(false);
    setActivoTiposBoletinAction(dispatch, null);
  };

  const toggleNewsletterModal = () => {
    setIsModalNewsletter((prev) => {
      if (prev) setActivoNewsletterAction(dispatch, null);
      return !prev;
    });
  };

  const handleBackToList = () => {
    dispatch({ type: SET_TIPOS_BOLETIN_ACTIVO, payload: null });
    setActivoNewsletterAction(dispatch, null);
    dispatch({ type: IS_LIST_TIPOS_BOLETIN, payload: true });
  };

  const handleNewBloque = () => {
    dispatch({ type: SET_NEWSLETTER_ACTIVO, payload: null });
    setIsModalNewsletter(true);
  };

  useEffect(() => {
    if (newsletterState.activo) setIsModalNewsletter(true);
  }, [newsletterState.activo]);

  return (
    <Container>
      <PageHeader>
        <TitleBlock>
          <h2>Newsletter</h2>
          <p>
            {isListView
              ? 'Administra los tipos de boletín y su contenido publicable.'
              : `Bloques del boletín "${tipoActivo?.nombre ?? ''}"`}
          </p>
        </TitleBlock>

        <Toolbar>
          {!isListView && (
            <>
              <Button color="light" size="sm" onClick={handleBackToList}>
                <FaArrowLeft style={{ marginRight: 6 }} />
                Volver a tipos
              </Button>
              <Button color="success" size="sm" onClick={handleNewBloque}>
                <FaPlus style={{ marginRight: 6 }} />
                Nuevo bloque
              </Button>
            </>
          )}
        </Toolbar>
      </PageHeader>

      {!isListView && tipoActivo && (
        <Breadcrumb>
          Tipos de boletín / <strong>{tipoActivo.nombre}</strong>
        </Breadcrumb>
      )}

      {isListView ? (
        <ListadoTiposBoletin
          onNew={() => openTipoModal(null)}
          onEdit={(tipo) => openTipoModal(tipo)}
        />
      ) : (
        <ListadoNewletter />
      )}

      <Modal
        isOpen={isModalTipo}
        toggle={closeTipoModal}
        centered
        size="md"
      >
        <ModalHeader toggle={closeTipoModal}>
          {tiposBoletinState.activo ? 'Editar tipo' : 'Nuevo tipo de boletín'}
        </ModalHeader>
        <ModalBody>
          <FormTiposBoletin onClose={closeTipoModal} />
        </ModalBody>
      </Modal>

      <Modal
        isOpen={isModalNewsletter}
        toggle={toggleNewsletterModal}
        centered
        style={{ maxWidth: '860px' }}
      >
        <ModalHeader toggle={toggleNewsletterModal}>
          {newsletterState.activo ? 'Editar bloque' : 'Nuevo bloque'}
        </ModalHeader>
        <ModalBody>
          <FormNewsletter isModal={setIsModalNewsletter} />
        </ModalBody>
      </Modal>
    </Container>
  );
};
